import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import Hero from "./home/Hero";
import TrustBand from "./home/TrustBand";
import UniqueFeatures from "./home/UniqueFeatures";
import Features from "./home/Features";
import IntegrationsBrief from "./home/IntegrationsBrief";
import TestimonialStrip from "./home/TestimonialStrip";
import SeoContentSection from "./home/SeoContentSection";
import { SectionSignupStrip } from "./home/HomeSignupCtas";
import PageSeo from "../../seo/PageSeo";
import { SITE_TAGLINE, DEFAULT_DESCRIPTION, DEFAULT_KEYWORDS } from "../../seo/siteConfig";
import { homePageJsonLd } from "../../seo/structuredData";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash !== "#features") return undefined;
    const t = window.setTimeout(() => {
      document.getElementById("features")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
    return () => window.clearTimeout(t);
  }, [location.pathname, location.hash]);

  return (
    <Box as="main">
      <PageSeo
        title={`${SITE_TAGLINE}`}
        description={DEFAULT_DESCRIPTION}
        keywords={DEFAULT_KEYWORDS}
        canonicalPath="/"
        jsonLd={homePageJsonLd()}
      />
      <Hero />
      <UniqueFeatures />
      <TrustBand />
      <Features />
      <IntegrationsBrief />
      <TestimonialStrip />
      <SeoContentSection />
      <Box px={{ base: 4, md: 6 }} py={{ base: 10, md: 14 }} maxW="container.xl" mx="auto">
        <SectionSignupStrip heading="Ready to try it? Create a free workspace in a minute—voice add-ons stay optional." />
      </Box>
    </Box>
  );
};

export default HomePage;
